import React from "react";
import { ListItem } from "@/features/shell/components/shared/List/List";
import { Skeleton } from "@picklebet/ui";
import * as styles from "./VerificationOptionSkeleton.module.scss";

type VerificationOptionSkeletonProps = {
  count?: number;
};

export const IoMVerificationOptionSkeleton = () => (
  <div className={styles.iomSkeletonWrapper}>
    <Skeleton
      shape={"rect"}
      span={"half"}
      className={styles.verifyButtonSkeleton}
    />
    <Skeleton shape={"rect"} size={"xs"} span={"quart"} />
  </div>
);

export const VerificationOptionSkeleton = ({
  count = 1,
}: VerificationOptionSkeletonProps) => (
  <>
    {Array.from({ length: count }).map((_, i) => (
      <ListItem label="" key={`option-skeleton-${i}`} />
    ))}
  </>
);
